// "Slow fly and orbit": an unhurried flight to the stop, then a slow turn round it for as long as the tour stays.
// moveOptions (`FlyOrbitOptions` in settings/typedefs.js, plus `travel`):
//   travel              seconds the flight takes (default 3.2)
//   orbitRate           radians per second round the target (default 0.05; negative turns the other way)
//   speed               `slow`, `medium`, `fast`: the builder's words, a factor on the rate (rig.js SPEED)
//   stayIncludesTravel  main's timing, written by `legacyTour`: the engine's own place flight, the stay counted from
//                       the start of that flight, and the turn at a constant rate from the moment the flight ends
import { ramp, speedOf } from './rig.js';

export default function flyOrbit(o, rig) {
  const rate = (Number.isFinite(o.orbitRate) ? o.orbitRate : 0.05) * speedOf(o), asMain = o.stayIncludesTravel === true;
  return {
    travel: Number.isFinite(o.travel) ? Math.max(0, o.travel) : asMain ? null : 3.2,
    hold: asMain,
    step(dt, t, len) { rig.turn(rate * dt * (asMain ? 1 : ramp(t, len))); },
  };
}
